import React from 'react'
import { BCol, BLink, BText, BTitle, BSpinner } from '@prague-digi/ui-components'

import Notification from '../../../../components/Notification/Notification'
import messages from '../../../../i18n'
import dots from '../../../../assets/identity/dots.svg'
import phone from '../../../../assets/identity/phone.svg'

import styles from '../../styles.scss'

interface Props {
  canSendSms: boolean
  phoneNumber: string
  sendSms: Function
  translate: Function
  translateHTML: Function
}

export const IdentitySms: React.FC<Props> = ({
  canSendSms,
  phoneNumber,
  sendSms,
  translate,
  translateHTML,
}: Props): React.ReactElement<Props> => (
  <>
    <BTitle type="h3">{translate(messages.identity.sms.title)}</BTitle>
    <BText>{translateHTML(messages.identity.sms.subtext, { phoneNumber })}</BText>

    <div className={styles.iconsContainer}>
      <div>
        <BSpinner isStatic isShown style={{ zIndex: '0' }} />
      </div>
      <div>
        <img src={dots} alt="dots" />
      </div>
      <div>
        <img src={phone} alt="phone" className={styles.phoneIcon} />
      </div>
    </div>

    <Notification type="warning" description={translateHTML(messages.identity.sms.warning)} />

    {canSendSms && (
      <BCol theme="text-center mt-3">
        <BText theme="d-inline" type="secondary">
          {translate(messages.identity.sms.noSms)}
        </BText>
        <BLink onClick={sendSms}>{translate(messages.identity.sms.sendSms)}</BLink>
      </BCol>
    )}
  </>
)
